import { Input } from '@thd-olt-component-react/input';
import PropTypes from 'prop-types';
import React from 'react';
import { emailRegex } from '@thd-olt-functional/utils';

const emailValidation = (fieldValue) => fieldValue.match(emailRegex);

const processEmailAddress = (fieldValue) => fieldValue.trim();

const header = (<span>Email Address<span style={{ color: 'red' }}>*</span></span>);

const CpaEmailAddressInput = (props) => {
  const { value, onChangeCallback } = props;
  return (
    <div>
      <div className="cpa-input__input-form-header">
        {header}
      </div>
      <Input
        name="emailAddress"
        className="cpa-form-input"
        errorText="Please enter a valid email address."
        value={processEmailAddress(value)}
        onChange={onChangeCallback}
        validation={emailValidation}
      />
    </div>
  );
};

CpaEmailAddressInput.propTypes = {
  onChangeCallback: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

CpaEmailAddressInput.displayName = 'CpaEmailInput';
export { CpaEmailAddressInput };
